import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React from 'react';
import ReactCookies from 'react-cookies';
import { useDispatch, useSelector } from 'react-redux';
import { COOKIES, LOCATION_SELECTED } from '../../brands/default/constants';
import { makeUrlAbsolute, redirectToURL } from '../../helpers/url';
import { setLocation } from '../../redux/actions/locations';
import { getNavigation } from '../../redux/actions/navigation';
import WowModal from '../WowModal';
import HeaderLocationList from './HeaderLocationList';

const HeaderLocationDropDown = ({ showModal = false, setShowModal }) => {
  const [locations, location] = useSelector((state) => [
    state.locations.locations,
    state.locations.location,
  ]);
  const lightboxLocation = ReactCookies.load(COOKIES.lightboxLocation);

  const locationObject = location || lightboxLocation;
  const dispatch = useDispatch();
  const router = useRouter();
  const countryCode = process.env.NEXT_PUBLIC_COUNTRY_CODE;

  const onSelectLocation = (locationToSet) => {
    dispatch(setLocation(locationToSet, true));

    dispatch(getNavigation(locationToSet));
    if (typeof window !== 'undefined') {
      const url = makeUrlAbsolute(`deals/${locationToSet.shortName}`);
      window.location.href = url;
      redirectToURL(url, router);
      localStorage.setItem(LOCATION_SELECTED, 'set');
    }
    setShowModal(false);
  };

  return (
    <>
      <WowModal
        ariaLabelledBy="id-choose-loc"
        backdropClassName="remove-backdrop"
        extraClasses="fullscreen-mobile remove-header with-fade-in no-body-padding"
        setShowModal={setShowModal}
        showModal={showModal}
        size="lg"
      >
        <HeaderLocationList
          countryCode={countryCode}
          locations={locations}
          onCancel={() => setShowModal(false)}
          onSelectLocation={onSelectLocation}
          selection={locationObject}
        />
      </WowModal>
    </>
  );
};

HeaderLocationDropDown.propTypes = {
  setShowModal: PropTypes.func,
  showModal: PropTypes.bool,
};

export default HeaderLocationDropDown;
